const stage = () => {
  let url = window.location.hostname;
  switch (url) {
    case "admin.verscan.com":
      return "prod";
    case "dev-admin.verscan.com":
      return "dev";
    case "uat-admin.verscan.com":
      return "uat";
    default:
      return "local";
  }
};

const baseUrl = () => {
  switch (stage()) {
    case "dev":
      return "https://api.verscan.com/register-dev";
    case "uat":
      return "https://api.verscan.com/register-uat";
    case "prod":
      return "https://verscan-register-dot-modified-alloy-333307.as.r.appspot.com";
    default:
      // return "http://localhost:4000";
      return "https://api.verscan.com/register-dev";
  }
};

export default baseUrl;
